import { LatestBlogPosts } from 'components/LatestBlogPosts'
import { ComponentType } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-bottom: 40px;

  ${up('sm')} {
    padding-bottom: 24px;
  }
`

export const Blog: ComponentType = () => (
  <Wrapper>
    <LatestBlogPosts />
  </Wrapper>
)
